module.exports = __webpack_public_path__ + "static/media/d1.b88128ce.jpg";